import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/testingActions'
import * as api from '../../api/job/testing'

import { message } from 'antd'

// FETCH
function* fetchTesting(action) {
  try {
    const payload = yield call(api.getTesting, action.jobId)
    yield put({ type: constants.FETCH_TESTING.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FETCH_TESTING.FAILED,
      message: e.message || e
    })
  }
}

function* watchTestingFetch() {
  yield takeLatest(constants.FETCH_TESTING.ACTION, fetchTesting)
}

// CREATE
function* sagaCreateTesting(action) {
  try {
    const payload = {
      formData: action.formData,
      jobId: action.jobId
    }
    message.warning('Creating Testing.')
    yield call(api.createTesting, payload)
    yield put({ type: constants.CREATE_TESTING.SUCCESS, payload })
    yield call(fetchTesting, { jobId: action.jobId })
    message.success('Testing created!')
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    message.error('Problems creating the Testing!')
    yield put({
      type: constants.CREATE_TESTING.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateTesting() {
  yield takeLatest(constants.CREATE_TESTING.ACTION, sagaCreateTesting)
}

// UPDATE
function* sagaUpdateTesting(action) {
  try {
    const payload = {
      formData: action.formData,
      jobId: action.jobId,
      testingId: action.testingId
    }
    message.warning('Updating Testing.')
    yield call(api.updateTesting, payload)
    yield put({ type: constants.UPDATE_TESTING.SUCCESS, payload })
    yield call(fetchTesting, { jobId: action.jobId })
    message.success('Testing Updated!')
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    message.error('Problems updating the Testing!')
    yield put({
      type: constants.UPDATE_TESTING.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateTesting() {
  yield takeLatest(constants.UPDATE_TESTING.ACTION, sagaUpdateTesting)
}

// DELETE
function* sagaDeleteTesting(action) {
  try {
    message.warning('Deleting Testing.')
    yield call(api.deleteTesting, action.testingId)
    yield put({ type: constants.DELETE_TESTING.SUCCESS })
    yield call(fetchTesting, { jobId: action.jobId })
    message.success('Testing Deleted!')
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    message.error('Problems deleting the Testing!')
    yield put({
      type: constants.DELETE_TESTING.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteTesting() {
  yield takeLatest(constants.DELETE_TESTING.ACTION, sagaDeleteTesting)
}

// ATTACHMENT SAGAS
function* uploadTestingAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      testingId: action.testingId
    }

    yield call(api.uploadTestingAttachments, payload)
    yield put({ type: constants.UPLOAD_TESTING_ATTACHMENT.SUCCESS, payload })
    yield call(fetchTestingAttachments, { testingId: action.testingId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_TESTING_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadTestingAttachments() {
  yield takeLatest(constants.UPLOAD_TESTING_ATTACHMENT.ACTION, uploadTestingAttachments)
}

function* fetchTestingAttachments(action) {
  try {
    const payload = yield call(api.fetchTestingAttachments, action.testingId)
    yield put({ type: constants.FETCH_TESTING_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FETCH_TESTING_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchTestingAttachments() {
  yield takeLatest(constants.FETCH_TESTING_ATTACHMENTS.ACTION, fetchTestingAttachments)
}

function* updateTestingAttachmentDescription(action) {
  try {
    console.log(action)
    const payload = {
      attachmentId: action.attachmentId,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_TESTING_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(fetchTestingAttachments, { testingId: action.testingId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_TESTING_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateTestingAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_TESTING_ATTACHMENT_DESCRIPTION.ACTION,
    updateTestingAttachmentDescription
  )
}

function* deleteTestingAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId
    }

    yield call(api.deleteTestingAttachment, payload)
    yield put({ type: constants.DELETE_TESTING_ATTACHMENT.SUCCESS, payload })
    yield call(fetchTestingAttachments, { testingId: action.testingId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_TESTING_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteTestingAttachments() {
  yield takeLatest(constants.DELETE_TESTING_ATTACHMENT.ACTION, deleteTestingAttachment)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchTestingFetch),
    fork(watchCreateTesting),
    fork(watchUpdateTesting),
    fork(watchDeleteTesting),

    fork(watchUploadTestingAttachments),
    fork(watchFetchTestingAttachments),
    fork(watchUpdateTestingAttachmentDescription),
    fork(watchDeleteTestingAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/testingSaga.js